import { ENDPOINTS } from "@/api/endpoints";
import { chatApiClient } from "@/lib/client";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

export interface ChatRequest {
  insightId: string;
  scheduledJobId: string;
  query: string;
}

export interface ChatResponse {
  response: string;
}

export const sendChatMessage = async (
  payload: ChatRequest
): Promise<ChatResponse> => {
  const response = await chatApiClient
    .post(ENDPOINTS.CHAT, { json: payload })
    .json<ChatResponse>();
  return response;
};

export const useChatMutation = (
  options?: UseMutationOptions<ChatResponse, Error, ChatRequest, unknown>
) => {
  return useMutation({
    mutationFn: (payload: ChatRequest) => sendChatMessage(payload),
    ...options,
  });
};

